<template>
<b-container class="bv-example-row">
    <Header></Header>
    <b-row>
      <b-col cols="12" class="hr"></b-col>
    </b-row>
    <b-row>
        <b-col cols="3">
          <Menu></Menu>
        </b-col>
        <b-col cols="9" class="border">
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="12" class="head">
                  <h4>:: Modelos</h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="breadcrumb">
                  <b-link :to="{ name: 'ModelsListByBrand' }">Modelos por marca</b-link> &raquo; <b-link :href="'/models-by-brand/brand/'+this.$route.params.slug">Lista de Oficinas de {{ this.model.brand }}</b-link>
                </b-col>
              </b-row>
              <div class="mt-2"></div>
              <b-form @submit="onSubmit">
                <b-form-group id="fieldsetHorizontal"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          label="Nombre del Modelo">
                  <b-form-input id="name" :state="state" v-model.trim="model.name"></b-form-input>
                </b-form-group>
                <b-form-group id="fieldsetHorizontal"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          label="URL Imagen">
                  <b-form-input id="name" :state="state" v-model.trim="model.image"></b-form-input>
                </b-form-group>
                // eslint-disable-next-line
                <b-button type="submit" variant="primary derco">Guardar</b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>
/*eslint-disable */
import axios from "axios";
import Header from './Header'
import Menu from './Menu'
String.prototype.strip = function() {
  var translate_re = /[öäüÖÄÜßËë ]/g;
  var translate = {
    "ä":"a", "ö":"o", "ü":"u", "Ë":"e", "Ë":"e",
    "Ä":"A", "Ö":"O", "Ü":"U",
    " ":"-", "ß":"ss"  
  };
    return (this.replace(translate_re, function(match){
        return translate[match];})
    );
};
export default {
  name: "CreateModel",
  components:{
    Header,
    Menu
  },
  data() {
    return {
      model: {
        name: null,
        brand: null,
        slug: null,
        image:null,
        status:1
      },
      brand: {}
    }
  },
  created(){
    if(localStorage.getItem('role')=="Administrador"){
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`/brand/slug/` + this.$route.params.slug)
      .then(response => {
        this.brand = response.data
        document.title = "Administración Derco - Brand " + response.data[0].name
        this.model.brand = response.data[0].name
        this.model.slug = response.data[0].slug
      })
      .catch(e => {
        this.errors.push(e)
        if(e.response.status === 401) {
          this.$router.push({
            name: 'Login'
          })
        }
      })
    }else{
      this.$router.push({
        name: 'Login'
      })
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios
        .post(`/models`, this.model)
        .then(response => {
          this.$router.push({
            name: "ShowModel",
            params: { id: response.data._id, slug: this.$route.params.slug }
          })
        })
        .catch(e => {
          this.errors.push(e);
        })
    },
    logout () {
      localStorage.removeItem('jwtToken')
      this.$router.push({
        name: 'Login'
      })
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/CreateModel.vue